export default __webpack_public_path__ + "static/media/drop-down.22a4c2b5.svg";